import React, { useState, useEffect } from 'react'
import CrudTable from '../table/crudtable'
import { referencePhotoService, authService, templateService } from '../../_services'
import ReferencePhotoForm from './referencephotoform.component'
import { useTranslation } from "react-i18next";
import { SERVER_URL } from '../../config';
import { Modal, Button } from 'react-bootstrap'

function ReferencePhoto() {

	const [templates, setTemplates] = useState([])
	const [referencePhotoTemplates, setReferencePhotoTemplates] = useState([])
	const [referencePhotoTemplatesDownloaded, setReferencePhotoTemplatesDownloaded] = useState(false)
	const [showTemplatesModal, setShowTemplatesModal] = useState(false)
	const [selectedReferencePhoto, setSelectedReferencePhoto] = useState(null)
    const {t} = useTranslation('common')

	const initialState = {
		id: '',
		name: '',
		description: '',
		data: null
	}

	useEffect(() => {
		templateService.list().then(data => {
			setTemplates(data)
			referencePhotoService.getReferencePhotoTemplates().then(data => {
				setReferencePhotoTemplates(data)
				setReferencePhotoTemplatesDownloaded(true)
			})
		})
    }, [])

	const nameFormatter = (cell, row) => {
		return <a href={SERVER_URL + "/referencePhoto/download/" + row.id} target="_blank">{cell}</a>
	}

	const descriptionFormatter = (cell) => {
		return cell || '-'
	}

	const templatesFormatter = function(cell, row) {
		if (referencePhotoTemplates && referencePhotoTemplates[row.id] && referencePhotoTemplates[row.id].length > 0) {
			return <a href="#" onClick={e => onTemplatesClick(e, row.id)}>{referencePhotoTemplates[row.id].length}</a>
		}
	    return 0
    }

    const onTemplatesClick = (e, referencePhotoId) => {
        e.preventDefault()

		setSelectedReferencePhoto(referencePhotoId)
		setShowTemplatesModal(true)
    }

    const onHide = () => {
		setShowTemplatesModal(false)
    }

	const columns = [
		{
			dataField: 'customerName',
			text: t('referencephoto.columns.customer'),
			sort: true,
			hidden: !authService.hasRoles(['ROLE_SUPER_ADMIN'])
		},
		{
			dataField: 'name',
			text: t('referencephoto.columns.name'),
			formatter: nameFormatter,
			sort: true
		},
		{
			dataField: 'description',
			text: t('referencephoto.columns.description'),
			formatter: descriptionFormatter,
			sort: true
		},
		{
            dataField: 'templates',
            text: t('referencephoto.columns.templates'),
            formatter: templatesFormatter,
            sort: true
        }
	]

	return (
		<div>
			<h2>
				{t('referencephoto.label')}
			</h2>
			{ referencePhotoTemplatesDownloaded &&
				<CrudTable
					service={referencePhotoService}
					columns={columns}
					initialState={initialState}
					form={<ReferencePhotoForm />}
					remote={{"filter": false, "search": false, "pagination": false}}
					sort={{dataField: 'name', order: 'asc'}}
					creatable={authService.hasRoles(['ROLE_REFERENCE_PHOTO_WRITE'])}
					editable={authService.hasRoles(['ROLE_REFERENCE_PHOTO_WRITE'])}
					deletable={authService.hasRoles(['ROLE_REFERENCE_PHOTO_WRITE'])}
					urlParams={true}
				/>
			}
			<Modal
				style={{overflow: 'scroll'}}
				size="md"
				show={showTemplatesModal}
				backdrop={true}
				onShow={() => console.log('onShow')}
				onHide={onHide}
				animation={false}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('suggestionlist.columns.templates')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{ selectedReferencePhoto &&
						<ul>
							{ templates.filter(template => referencePhotoTemplates[selectedReferencePhoto].includes(template.id)).map(template => {
								return <li key={template.id}>
									<a href={'/template/details/' + template.id} target="_blank">{template.name}</a>
								</li>
							})}
						</ul>
					}
				</Modal.Body>
				<Modal.Footer>
					<Button variant="outline-primary" onClick={onHide}>
						{t('crudtable.ok')}
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	)
}

export default ReferencePhoto;